<template>
  <div class="g-bd">
    <!-- banner -->
    <div class="con-banner">
      <el-carousel trigger="click" height="400px" arrow="never">
        <a
          :href="item.linkUrl ? `${item.linkUrl}` : 'javascript:void(0);'"
          v-for="item in bannerList"
          :key="item.id"
          :target="item.linkUrl ? '_blank' : '_self'"
        >
          <el-carousel-item
            :style="`background:${item.backgroundColor};background-size: cover;
-webkit-background-size: cover;
-o-background-size: cover;
zoom: 1;`"
          >
            <div
              :class="
                $route.query.siteId == 6 ? 'item-con rural-promote' : 'item-con'
              "
            >
              <img :src="imgUrl + item.path" alt />
            </div>
          </el-carousel-item>
        </a>
      </el-carousel>
    </div>
    <div class="container course-list">
      <div class="list-title">
        <div class="title-text">
          {{ $route.query.tagName }}
        </div>
      </div>
      <div class="list-filter">
        <div :class="sortType == '' ? 'current' : ''" @click="sortType = ''">
          最新
        </div>
        <div :class="sortType == 2 ? 'current' : ''" @click="sortType = 2">
          最新
        </div>
        <div :class="sortType == 1 ? 'current' : ''" @click="sortType = 1">
          最热
        </div>
      </div>
      <div class="list-content">
          <ul class="con-course f-clearfix" >
                <li
                  v-for="(item, index) in courseList"
                  :key="index"
                  :title="item.name"
                >
                  <div
                    v-if="item.tagId != null"
                    id="item-course-tags-b"
                    :class="
                      item.tagId == '1169810873999269889'
                        ? 'tagA'
                        : item.tagId == '1242344957122658306'
                        ? 'tagB'
                        : 'tagC'
                    "
                  ></div>
                  <div
                    v-if="item.tagId != null"
                    id="item-course-tags"
                    :class="
                      item.tagId == '1169810873999269889'
                        ? 'tagA'
                        : item.tagId == '1242344957122658306'
                        ? 'tagB'
                        : 'tagC'
                    "
                  >
                    <span :title="item.tagTitle">{{ item.tagTitle }}</span>
                    <!-- <span v-else-if="item.tagTitle == '1242344957122658306'">{{
                      item.tagTitle
                    }}</span> -->
                  </div>
                  <a :href="item.ctUrl" target="_blank">
                    <div class="item-img">
                      <img v-img.lazy="item.ctImgUrl" :alt="item.name" />
                    </div>
                    <h3>{{ item.name }}</h3>
                    <div>
                      <span class="item-school">{{ item.schoolName }}</span>
                      <span class="item-edu">
                        {{ item.enrollCount || 0 }}人选课
                      </span>
                    </div>
                  </a>
                </li>
              </ul>
        <div class="m-pagination-wrapper">
          <el-pagination
            class="m-pagination"
            @current-change="newPage"
            :page-size="newPageList.pageSize"
            :hide-on-single-page="true"
            :current-page.sync="newPageList.pageNo"
            :total="newPageList.total"
            layout=" prev, pager, next"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgUrl: this.$setting.fdsDomain,
      bannerList: [],
      sortType: '',
      newPageList: {
        pageSize: 20,
        pageNo: 1,
        total: 0,
      },
      courseList: [],
    };
  },
  watch: {
    sortType(v) {
        this.newPageList.pageNo = 1;
        this.getCourse();
    },
  },
  mounted() {
    this.getbanner();
    this.getCourse();
  },
  methods: {
    getbanner() {
      let par = {
        tagCourseId: 5,
      };
      this.$http.post("/api/web/banner/list", par).then((res) => {
        this.bannerList = res.data;
        // this.sysCountPV();
      });
    },
    newPage(val) {
      this.newPageList.pageNo = val;
      this.getCourse();
    },
    getCourse() {
      let par = {
        pageSize: this.newPageList.pageSize,
        currentPage: this.newPageList.pageNo,
        categoryId: "",
        sortType: this.sortType,
        search: "",
        tagList:this.$route.query.tagId,
        status: "",
        collegeId: "",
      };
      this.$http.post("/api/web/course/list", par).then((res) => {
        this.courseList = res.data.records;
        this.newPageList.total = res.data.total;
        this.newPageList.pageNo = res.data.current;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.g-bd{
    min-height: calc(100vh - 168.6px);
}
.con-banner {
  height: 400px;
  width: 100%;
  margin: 0 auto;
  // overflow: hidden;
  display: flex;
  justify-content: space-between; // position: relative;

  .el-carousel {
    flex: 1;
    overflow: hidden;
    .el-carousel__container {
      margin: 0 auto;
      .item-con {
        position: relative;
        height: 400px;
        margin: 0 auto;
        width: auto;
        display: flex;
        justify-content: center;
        align-content: center;
      }
    }
  }

  .el-carousel__item img {
    // width: 100%;
    height: 100%;
    margin: 0 auto;
    display: block;
  }
}
.course-list {
  min-width: 1200px;
  .list-title {
    text-align: center;
    .title-text {
      margin: 60px auto 40px auto;
      text-align: center;
      font-size: 34px;
      position: relative;
      display: inline-block;
      &::before {
        content: "";
        position: absolute;
        top: 25px;
        left: -100px;
        width: 53px;
        height: 2px;
        background-color: #333333;
      }
      &::after {
        content: "";
        position: absolute;
        top: 25px;
        right: -100px;
        width: 53px;
        height: 2px;
        background-color: #333333;
      }
    }
    // width: 150px;
  }
  .list-filter {
    display: flex;
    font-size: 14px;
    line-height: 36px;
    margin-bottom: 25px;
    div {
      margin-right: 40px;
      cursor: pointer;
      &.current {
        color: #3685fd;
        border-bottom: 2px solid #3685fd;
      }
    }
  }
  .con-course {
      width: 100%;
      padding: 0 -32px;
      margin-left: 0;
      :nth-child(4n) {
        margin-right: 0px;
      }
      li {
        width: 277.5px;
        margin-right: 30px;
        margin-left: 0;
        margin-bottom: 25px;
        .item-img {
          width: 270px;
          height: 162px;
          img {
            width: 100%;
          }
        }
        div {
          // height: 40px;
          // line-height: 40px;
          span {
            color: #777;
            font-size: 12px;
          }

          .item-school {
            float: left;
            width: 120px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .item-edu {
            float: right;
            text-align: right;
          }
        }
      }
    }
}
</style>